/* Dr. Replenish PDP buy-box. Reads real variant + selling-plan data injected by the template. */
(function(){
  var V = (window.REP_VARIANTS || []).filter(function(v){ return v && v.id; });
  var PLAN = window.REP_PLAN || null; /* { id: <selling_plan_id>, pct: <number> } or null */
  if(!V.length) return;

  function packCount(t){ var m=(t||'').match(/(\d+)/); return m ? parseInt(m[1],10) : 1; }
  function money(c){ return '$' + (c/100).toFixed(2); }

  var base3 = (V.filter(function(v){return packCount(v.title)===3;})[0] || V[0]).price || 1795;

  var state = { variant: V[0], plan: 'one' };
  var six = V.filter(function(v){ return packCount(v.title)===6; })[0];
  if(six) state.variant = six;          /* default to 6-pack */
  if(PLAN) state.plan = 'sub';          /* default to subscribe when a plan exists */

  function priceFor(variant, plan){
    var p = variant.price;
    if(plan==='sub' && PLAN){ p = Math.round(p * (1 - PLAN.pct/100)); }
    return p;
  }

  function render(){
    var v = state.variant;
    /* per-pack labels */
    document.querySelectorAll('.pack').forEach(function(el){
      var pv = V.filter(function(x){ return String(x.id)===el.getAttribute('data-vid'); })[0];
      if(!pv) return;
      var c = packCount(pv.title);
      var per = priceFor(pv, state.plan)/c;
      var save = Math.round((1 - per/(base3/3))*100);
      var perEl = el.querySelector('[data-per]');
      if(perEl){ perEl.innerHTML = money(per) + ' <span>/ shot</span>'; }
      var pill = el.querySelector('[data-pill]');
      if(pill){
        if(c===3){ pill.textContent='Starter'; pill.style.color='var(--muted)'; pill.style.background='var(--bone-2)'; }
        else if(save>0){ pill.textContent='Save '+save+'%'; pill.style.color=''; pill.style.background=''; }
        else { pill.textContent=''; }
      }
    });
    /* headline + hidden inputs */
    var total = priceFor(v, state.plan);
    var was = (state.plan==='sub' && PLAN) ? ' <span class="was">'+money(v.price)+'</span>' : '';
    var atcP = document.getElementById('atcPrice'); if(atcP){ atcP.innerHTML = money(total) + was; }
    var sp = document.getElementById('stickyPrice'); if(sp){ sp.textContent = money(total); }
    var ss = document.getElementById('stickySave'); if(ss){ ss.textContent = (state.plan==='sub' && PLAN) ? 'Subscribe & save '+PLAN.pct+'%' : 'One-time purchase'; }
    var vi = document.getElementById('variantId'); if(vi){ vi.value = v.id; }
    var spn = document.getElementById('sellingPlan'); if(spn){ spn.value = (state.plan==='sub' && PLAN) ? PLAN.id : ''; }
  }

  document.querySelectorAll('.pack').forEach(function(el){
    el.addEventListener('click', function(){
      document.querySelectorAll('.pack').forEach(function(x){ x.classList.remove('is-active'); });
      el.classList.add('is-active');
      var pv = V.filter(function(x){ return String(x.id)===el.getAttribute('data-vid'); })[0];
      if(pv){ state.variant = pv; }
      render();
    });
  });
  document.querySelectorAll('#ptype .pt').forEach(function(el){
    el.addEventListener('click', function(){
      document.querySelectorAll('#ptype .pt').forEach(function(x){ x.classList.remove('is-active'); });
      el.classList.add('is-active');
      state.plan = el.getAttribute('data-type');
      render();
    });
  });
  document.querySelectorAll('.thumb').forEach(function(t){
    t.addEventListener('click', function(){
      document.querySelectorAll('.thumb').forEach(function(x){ x.classList.remove('is-active'); });
      t.classList.add('is-active');
      var f = t.getAttribute('data-full'); if(f){ var g=document.getElementById('gimg'); if(g) g.src=f; }
    });
  });
  var satc = document.getElementById('satc');
  if(satc){ satc.addEventListener('click', function(){ var f=document.getElementById('atcForm'); if(f) f.submit(); }); }

  render();
})();
